var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_vm._v("\nEdit News\n"),_c('div',[_vm._v(_vm._s(this.newsToEdit.id))])])}
var staticRenderFns = []

export { render, staticRenderFns }